// GrowthBook variant experiment — widget-phone-field-position-202607.
// Tests whether collecting the pre-fit-call phone number at LeadCapture
// (step 1, required) instead of GetSetUp (post-booking, optional) improves
// conversion.
//
// Feature key configured in the GrowthBook UI: "phone-field-position"
// (string feature, values below).
//
// This experiment does NOT introduce its own phone UI. The widget already
// renders the phone field in both positions — that's the existing "phone
// flavour" (`data-cc-phone`, see main.tsx readPhoneMandatory). The experiment
// only chooses which flavour an un-pinned mount gets, so control is
// byte-for-byte today's production behavior.

export const PHONE_FIELD_POSITION_FEATURE = 'phone-field-position'

export const PHONE_FIELD_POSITION_CONTROL = 'input-final-step'
export const PHONE_FIELD_POSITION_TREATMENT = 'input-first-step'

export type PhoneFieldPosition =
    | typeof PHONE_FIELD_POSITION_CONTROL
    | typeof PHONE_FIELD_POSITION_TREATMENT
